/* Matraws — kollektion: tæthed-toggle + quick-filter-pills.
   Pills kobler på JERES egne facet-checkboxes via et rigtigt klik — rører ikke
   kerne-filter-JS'en. INGEN skjul/flyt af udsolgte: kortene vises i temaets
   standard-rækkefølge (den logik er bevidst fjernet). */
(function () {
  if (window.__mtwCol) return;
  window.__mtwCol = 1;

  var DKEY = 'mtwDensity';
  function lget(k, d) { try { return localStorage.getItem(k) || d; } catch (e) { return d; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function grids() { return document.querySelectorAll('[data-collection-products]'); }
  function cbBy(name, val) {
    var scope = document.getElementById('FiltersForm') || document;
    var list = scope.querySelectorAll('input.checkbox-input[name="' + name + '"]');
    for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('value') === val) return list[i]; }
    return null;
  }
  function toggleCb(cb) { if (cb && typeof cb.click === 'function') cb.click(); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var obs = null;
  function connect() {
    var host = document.getElementById('CollectionProductsParent');
    if (!host || !('MutationObserver' in window)) return;
    if (!obs) { var t; obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 80); }); }
    obs.observe(host, { childList: true, subtree: true });
  }

  /* --- TÆTHED --- */
  function applyDensity() {
    var d = lget(DKEY, 'normal');
    grids().forEach(function (grid) { grid.classList.toggle('mtw-dense', d === 'dense'); });
    document.querySelectorAll('[data-mtw-density] .mtw-dn-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-density') === d);
    });
  }

  /* --- QUICK-FILTER-PILLS (genereret fra jeres facetter) --- */
  var pillGroups = [
    { name: 'filter.v.availability', only: '1', label: 'På lager' },
    { name: 'filter.p.m.custom.card_rarity', max: 7 }
  ];
  function buildPills() {
    var host = document.querySelector('[data-mtw-quickfilters]');
    if (!host || host.getAttribute('data-built')) return;
    var html = '';
    pillGroups.forEach(function (g) {
      if (g.only) {
        if (cbBy(g.name, g.only)) html += '<button type="button" class="mtw-qf-pill" data-facet="' + g.name + '" data-val="' + g.only + '">' + (g.label || g.only) + '</button>';
        return;
      }
      var cbs = document.querySelectorAll('input.checkbox-input[name="' + g.name + '"]');
      for (var i = 0; i < cbs.length && i < (g.max || 8); i++) {
        var v = cbs[i].getAttribute('value');
        if (!v) continue;
        html += '<button type="button" class="mtw-qf-pill" data-facet="' + g.name + '" data-val="' + esc(v) + '">' + esc(v) + '</button>';
      }
    });
    if (html) { host.innerHTML = html; host.setAttribute('data-built', '1'); }
  }
  function syncPills() {
    document.querySelectorAll('[data-mtw-quickfilters] .mtw-qf-pill').forEach(function (p) {
      var cb = cbBy(p.getAttribute('data-facet'), p.getAttribute('data-val'));
      p.classList.toggle('is-active', !!(cb && cb.checked));
      p.classList.toggle('mtw-qf-gone', !cb);
    });
  }

  function sync() {
    if (obs) obs.disconnect();
    applyDensity();
    buildPills();
    syncPills();
    if (obs) connect();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var dn = e.target.closest('.mtw-dn-btn');
    var qf = e.target.closest('.mtw-qf-pill');
    if (dn) { e.preventDefault(); lset(DKEY, dn.getAttribute('data-density')); applyDensity(); }
    else if (qf) { e.preventDefault(); toggleCb(cbBy(qf.getAttribute('data-facet'), qf.getAttribute('data-val'))); }
  });

  function init() { connect(); sync(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
